export const FIRST_MONDAY_INDEX = 1;
export const NEXT_MONDAY_INDEX = 8;
export const DAYS_IN_WEEK_COUNT = 7;
export const FIRST_WEEK = 'first_week';
export const NEXT_WEEK = 'next_week';

export const DIRECTION_BACKWARD = 'right';
export const DIRECTION_FORWARD = 'left';
